module.exports = __webpack_public_path__ + "static/img/icon-12.57dd4e28.png";